module.exports = ".paddingBottom{\n    padding-bottom: 11%;\n}"